module.exports = __webpack_public_path__ + "static/wombat-cb28c580f7a4abae3499b9dabb56cc8b.mp4";